
enum SeatingStyle {
    CLUSTER ,
    USHAPED,
    CLASSROOM
}

export default SeatingStyle